<template>
  <div>
    <el-dialog
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <template slot="title">
        <span class="f-s-16">
          <span>选择采购申请明细</span>
          <span class="c-red">(已选{{ selfList.length }})</span>
        </span>
      </template>
      <div class="page-main">
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 310"
          @keydown="tableKeydown"
          @checkbox-change="tableCheckboxChange"
          @checkbox-all="tableCheckboxChange"
        >
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              :filterData="filterData"
              :value="filterData[column.field]"
              placeholder="输入关键字"
              @change="headerFilterChange"
            />
          </template>
          <template #default_bill_code="{ row }">
            <span>{{ row.shen_gou_code }}</span>
            <el-link type="primary" @click="itemCheckAll(row)"> 全选当前单号 </el-link>
          </template>
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      filterData: {},
      headerFilterUrl: '/admin/gcvip/shengou3/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        checkboxConfig: {
          trigger: 'row',
          reserve: true
        },
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { fixed: 'left', type: 'checkbox', width: 40 },
          { fixed: 'left', title: '序号', type: 'seq', width: 40 },
          {
            field: 'shen_gou_code',
            title: '采购申请单号',
            slots: { header: 'header_input', default: 'default_bill_code' }
          },
          { field: 'supplier_name', title: '供应商', slots: { header: 'header_input' } },
          { field: 'shen_gou_date', title: '申请日期', slots: { header: 'header_input' } },
          { field: 'name', title: '物料名称', width: 120, slots: { header: 'header_input' } },
          { field: 'spec', title: '规格(mm)', width: 120, slots: { header: 'header_input' } },
          { field: 'unit', title: '单位', width: 60, slots: { header: 'header_input' } },
          { field: 'shen_gou_counts', title: '申购数量', slots: { header: 'header_input' } },
          { field: 'goods_price', title: '单价(元)', slots: { header: 'header_input' } },
          { field: 'shen_gou_amount', title: '金额(元)', slots: { header: 'header_input' } }
        ],
        data: []
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    // 已选中的入库明细，反向映射为采购源行的 source_item_id，用于回显勾选
    this.selfList = this.list
      .filter((item) => item.source_item_id)
      .map((item) => ({ source_item_id: item.source_item_id }))
    this.searchListData()
  },
  methods: {
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        filterData: this.filterData,
        sortData: { id: 'desc' }
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengou3/list',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = this.$util.deepCopy(res.data.page.list) || []
            this.tableOptions.data.forEach((item) => {
              // source_item_id 取采购明细行 id(b_id)，作为去重键；source_bill_id 取采购单 id
              item.source_item_id = item.b_id || item.bind_id
              item.source_bill_id = item.shen_gou_bill_id || item.a_id
            })
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
            // 回显跨页选中
            this.tableOptions.data.forEach((itemSt) => {
              this.selfList.forEach((itemNd) => {
                if (itemNd.source_item_id === itemSt.source_item_id) {
                  this.$nextTick(() => {
                    this.$refs.refTable.setCheckboxRow([itemSt], true)
                  })
                }
              })
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    tableCheckboxChange(params) {
      let resultDiff = this.selfList.filter((itemSt) => {
        return this.tableOptions.data.every((itemNd) => itemSt.source_item_id !== itemNd.source_item_id)
      })
      let resultCheck = [...params.records]
      this.selfList = [...resultDiff, ...resultCheck]
    },
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        params.$event.preventDefault()
        let row = this.$refs.refTable.getCurrentRecord()
        let isChecked = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isChecked)
      }
    },
    itemCheckAll(row) {
      let rows = this.tableOptions.data.filter((item) => item.shen_gou_code === row.shen_gou_code)
      setTimeout(() => {
        this.$refs.refTable.setCheckboxRow(rows, true)
      })
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
